<script lang="ts" setup>
import { formatTimeToHMS } from '~/utils'

const { badgeType = 'default' } = defineProps<{
  badgeType?: 'default' | 'mobile' | string
}>()

const epochStore = useEpochStore()
const epochNumber = computed(() => epochStore.epochNumber > 0 ? epochStore.epochNumber : '-')
const epochProgress = computed(() => +epochStore.epochProgress)
const epochTimeRemaining = computed(() => epochStore.epochTimeRemaining)

const time = computed(() => formatTimeToHMS(epochTimeRemaining.value))
</script>

<template>
  <div class="epoch-badge" :class="[`epoch-badge-${badgeType}`]">
    <div class="epoch-badge__value">
      <span class="text-sm text-weight-regular">Epoch {{ epochNumber }}</span>
      <span class="text-xs text-weight-regular">{{ time }}</span>
    </div>
    <div v-if="badgeType === 'default'" class="epoch-badge__circle">
      <q-circular-progress :value="epochProgress" size="50px" color="badge-bg" track-color="badge-track" />
    </div>
    <div v-else class="epoch-badge__linear">
      <q-linear-progress :value="epochProgress / 100" color="primary" track-color="white-01" />
    </div>
  </div>
</template>
